import { Link } from "react-router-dom";
import { Container } from "@/components";
import styles from "./footer.module.css";
import { ArrowUp } from "lucide-react";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.footerContent}>
          <div className={styles.footerGrid}>
            <div className={styles.footerColumn}>
              <span className={styles.footerLinkLabel}>Contact Us</span>
              <ul className={styles.footerNav}>
                <li className={styles.footerNavItem}>
                  <a
                    className={styles.footerLink}
                    href="mailto:patrick@hwconcrete.com"
                  >
                    patrick@hwconcrete.com
                  </a>
                </li>
              </ul>
              <p className={styles.footerInfo}>(321)208-0016</p>
            </div>

            <div className={styles.footerColumn}>
              <span className={styles.footerLinkLabel}>Site Links</span>
              <ul className={styles.footerNav}>
                <li className={styles.footerNavItem}>
                  <Link className={styles.footerLink} to="/">
                    Home
                  </Link>
                </li>
                <li className={styles.footerNavItem}>
                  <Link className={styles.footerLink} to="/services">
                    Concrete Services
                  </Link>
                </li>
                <li className={styles.footerNavItem}>
                  <Link className={styles.footerLink} to="/gallery">
                    Project Gallery
                  </Link>
                </li>
                <li className={styles.footerNavItem}>
                  <Link className={styles.footerLink} to="/contact">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <div className={styles.footerColumn}>
              <span className={styles.footerLinkLabel}>Find Us On</span>
              <ul className={styles.footerNav}>
                <li className={styles.footerNavItem}>
                  <a
                    className={styles.footerLink}
                    href="https://www.facebook.com/patrick.haysbrook.2025"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>
                </li>
                <li className={styles.footerNavItem}>
                  <a
                    className={styles.footerLink}
                    href="https://www.instagram.com/hwconcrete321/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>
                </li>
              </ul>
            </div>
            <div className={styles.footerColumn}>
              <a className={styles.top} href="#top">
                <ArrowUp size={32} />
              </a>
            </div>
          </div>

          <div className={styles.footerBottom}>
            <p className={styles.copyright}>
              Website design by{" "}
              <a
                className={styles.footerLinkMysite}
                href="https://www.nickpinodesigns.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Nick Pino Designs, LLC.
              </a>
              &copy;2011-2025
            </p>
            <span id="siteseal">
              <script
                async
                type="text/javascript"
                src="https://seal.godaddy.com/getSeal?sealID=SNa4b1Gw3I62II9tG7XT8n5zB469gBoZP8tTDsLDYa5Uct07CJQbtt0im1yJ"
              />
            </span>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
